"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _uiUtil = require("@ctmobile/ui-util");

var selectorPrefix = 'ct-tree-';
var normalTriggerIcon = 'fa fa-caret-right';
var remoteTriggerIcon = 'fa fa-spinner';
var checkboxIcon = {
  checkall: 'check-square',
  // checkbox选中
  uncheckall: 'minus-square',
  // checkbox减号
  unchecked: 'square-o' // checkbox默认

};
var radioIcon = {
  checked: 'circle',
  //  radio选中
  unchecked: 'circle-o' // radio未选中

};
/**
 * initVar
 * @access private
 */

function initVar() {
  this.itemEl = this.el.querySelector(".".concat(selectorPrefix, "item"));
  this.itemTriggerEl = this.itemEl.querySelector(".".concat(selectorPrefix, "item-trigger"));
  this.itemIconEl = this.itemEl.querySelector(".".concat(selectorPrefix, "item-icon"));
  this.itemLabelEl = this.itemEl.querySelector(".".concat(selectorPrefix, "item-label"));
  this.itemTextEl = this.itemLabelEl.querySelector(".".concat(selectorPrefix, "item-text"));
  this.itemInputEl = this.itemEl.querySelector(".".concat(selectorPrefix, "item-input"));
  this.itemInputFieldEl = this.itemEl.querySelector(".".concat(selectorPrefix, "item-input-field"));
  this.childrenEl = this.el.querySelector(".".concat(selectorPrefix, "children"));
}
/**
 * initEvents
 * @access private
 */


function initEvents() {
  var _this = this;

  var loadType = this.config.loadType;

  if (this.itemTriggerEl) {
    // expand
    this.itemTriggerEl.addEventListener('click', function () {
      // 展开
      if (!_this.extend) {
        if (loadType === 'remote') {
          if (_this.isload) {
            _expand.call(_this, !_this.isExpand);
          } else {
            if (_this.lock) return false;
            _this.lock = true; // 先loading

            changeRemoteIcon.call(_this);

            _this.events.trigger('loadRemote', _this, onLoadRemoteSuccess.bind(_this), onLoadRemoteError.bind(_this), onLoadRemoteComplete.bind(_this));
          }
        } else {
          _expand.call(_this, !_this.isExpand);
        }
      } else {
        _expand.call(_this, !_this.isExpand);
      }
    });
  } // 点击了label


  this.itemLabelEl.addEventListener('click', function () {
    _this.events.trigger('click', _this);
  }); // 点击了checkbox

  if (this.itemInputEl) {
    this.itemInputEl.addEventListener('click', function () {
      if (_this.isChecked()) {
        if (_this.getType() === 'checkbox') {
          _this.checked(false);
        }
      } else if (_this.getType() === 'checkbox') {
        _this.checked(true);
      }
    });
  }
}
/**
 * checked
 * @param {boolean} - checked
 * @access private
 */


function checked(checked) {
  if (this.isCheckboxType()) {
    if (this.getType() === 'checkbox') {
      this.itemInputFieldEl.checked = checked;
      var _this$config$checkedC = this.config.checkedCascade,
          checkedCascade = _this$config$checkedC === void 0 ? true : _this$config$checkedC;

      if (checkedCascade && !this.isLeaf()) {
        for (var i = 0; i < this.childrenNodes.length; i++) {
          var treeNode = this.childrenNodes[i];
          treeNode.checked(checked);
        }
      }
    }
  }
}
/**
 * checkedDetail
 * @param {boolean} - check
 * @access private
 */


function checkedDetail(check) {
  var _this$config$checkedC2 = this.config.checkedCascade,
      checkedCascade = _this$config$checkedC2 === void 0 ? true : _this$config$checkedC2;
  checked.call(this, check);

  if (checkedCascade) {
    if (this.isLeaf()) {
      this.events.trigger('checked', this, check);
      this.detailItemInputsRecursive();
    }
  } else {
    this.detailItemInputsRecursive();
    this.events.trigger('checked', this, check);
  }
}
/**
 * changeRemoteIcon
 * @access private
 */


function changeRemoteIcon() {
  _uiUtil.Dom6.removeClass(this.itemTriggerEl, normalTriggerIcon);

  _uiUtil.Dom6.addClass(this.itemTriggerEl, "".concat(remoteTriggerIcon, " animation"));
}
/**
 * getChildrenPaddingLeft
 * @access private
 * @return {number}
 */


function getChildrenPaddingLeft() {
  var _this$config = this.config,
      leaf = _this$config.leaf,
      type = _this$config.type,
      icon = _this$config.icon;
  var paddingLeft = 4;

  if (!leaf) {
    paddingLeft += 22;
  }

  if (type !== 'normal') {
    if (icon) {
      paddingLeft += 19;
    } else {
      paddingLeft += 22;
    }
  } else if (icon) {
    paddingLeft += 19;
  } // item-trigger 22
  // item-input 22
  // item-icon 19
  // 4


  return paddingLeft;
}
/**
 * changeNormalIcon
 * @access private
 */


function changeNormalIcon() {
  _uiUtil.Dom6.removeClass(this.itemTriggerEl, "".concat(remoteTriggerIcon, " animation"));

  _uiUtil.Dom6.addClass(this.itemTriggerEl, normalTriggerIcon);
}
/**
 * expand
 * @param {Boolean} - expand
 * @access private
 */


function _expand(expaned) {
  if (this.isLeaf()) return false;
  if (this.isExpand === expaned) return false;

  if (expaned) {
    _uiUtil.Dom6.addClass(this.el, 'expand');
  } else {
    _uiUtil.Dom6.removeClass(this.el, 'expand');
  }

  this.isExpand = expaned;
  this.events.trigger('expand', this, this.isExpand);
}
/**
 * onLoadRemote
 * @param {Array} - children
 * @access private
 */


function onLoadRemoteSuccess(children) {
  var nodeGlobalConfig = this.nodeGlobalConfig,
      nodeConfig = this.nodeConfig; // if (children.length <= 0) return false;

  if (children.length <= 0) {
    nodeConfig.leaf = true;
    this.itemTriggerEl.classList.add('invisible');
  } // 清空之前的


  this.childrenNodes = [];
  nodeConfig.children = children;
  this.tree.renderChildren({
    parentNode: this,
    globalConfig: nodeGlobalConfig,
    config: nodeConfig
  });

  _expand.call(this, true);

  changeNormalIcon.call(this);
  this.isload = true;
  this.refresh();
  this.lock = false;
}
/**
 * onLoadRemoteError
 * @access private
 */


function onLoadRemoteError() {
  changeNormalIcon.call(this);
  this.lock = false;
}
/**
 * onLoadRemoteComplete
 * @access private
 */


function onLoadRemoteComplete() {
  changeNormalIcon.call(this);
  this.lock = false;
}
/**
 * renderInput
 * @access private
 * @return {String}
 */


function renderInput() {
  var _this$config2 = this.config,
      type = _this$config2.type,
      _this$config2$checked = _this$config2.checked,
      checked = _this$config2$checked === void 0 ? false : _this$config2$checked,
      leaf = _this$config2.leaf; // 普通的节点

  if (type === 'normal') {
    return '';
  } else if (type === 'checkbox') {
    // checkbox节点
    // 选中
    // if(isLeaf() && checked) {
    //   渲染成选中
    //   if(父节点的所有checkbox节点都选中) {
    //     父节点渲染成选中状态 - 一直向上追溯
    //   }
    // }
    // let str;
    // // 叶子节点
    // if (this.isLeaf()) {
    //   if (checked) {
    //     // 叶子节点且选中
    //     str = `<span class="${selectorPrefix}item-input fa fa-${checkboxIcon.checkall}" >
    //             <input class="${selectorPrefix}item-input-field" checked type="checkbox" />
    //            </span>`;
    //     //   if(父节点的所有checkbox节点都选中) {
    //     //     父节点渲染成选中状态 - 一直向上追溯
    //     //   }
    //     // Drill up
    //     if (this.parentNode) {
    //       this.parentNode.checkboxDrillUp();
    //     }
    //   } else {
    //     // 叶子节点非选中
    //     str = `<span class="${selectorPrefix}item-input fa fa-${checkboxIcon.unchecked}" >
    //             <input class="${selectorPrefix}item-input-field" type="checkbox" />
    //            </span>`;
    //   }
    // } else {
    //   // 非叶子节点
    //   str = `<span class="${selectorPrefix}item-input fa fa-${checkboxIcon.unchecked}" >
    //           <input class="${selectorPrefix}item-input-field" type="checkbox" />
    //          </span>`;
    // }
    var str = '';

    if (leaf) {
      if (checked) {
        str = "<span class=\"".concat(selectorPrefix, "item-input fa fa-").concat(checkboxIcon.checkall, "\" >\n              <input class=\"").concat(selectorPrefix, "item-input-field\" checked type=\"checkbox\" />\n             </span>");
      } else {
        str = "<span class=\"".concat(selectorPrefix, "item-input fa fa-").concat(checkboxIcon.unchecked, "\" >\n              <input class=\"").concat(selectorPrefix, "item-input-field\" type=\"checkbox\" />\n             </span>");
      }
    } else {
      str = "<span class=\"".concat(selectorPrefix, "item-input fa fa-").concat(checkboxIcon.unchecked, "\" >\n              <input class=\"").concat(selectorPrefix, "item-input-field\" type=\"checkbox\" />\n             </span>");
    }

    return str;
  } else if (type === 'radio') {
    // radio节点
    return "<span class=\"".concat(selectorPrefix, "item-input fa fa-").concat(radioIcon.unchecked, "\" >\n             <input class=\"").concat(selectorPrefix, "item-input-field\" type=\"checkbox\" />\n            </span>");
  } else {
    // 没有匹配的类型
    return '';
  }
}
/**
 * renderCheckboxCheckAll
 * @access private
 */


function renderCheckboxCheckAll() {
  _uiUtil.Dom6.removeClass(this.itemInputEl, "fa-".concat(checkboxIcon.uncheckall, " fa-").concat(checkboxIcon.unchecked));

  _uiUtil.Dom6.addClass(this.itemInputEl, "fa-".concat(checkboxIcon.checkall));
}
/**
 * renderCheckboxUncheckall
 * @access private
 */


function renderCheckboxUncheckall() {
  _uiUtil.Dom6.removeClass(this.itemInputEl, "fa-".concat(checkboxIcon.checkall, " fa-").concat(checkboxIcon.unchecked));

  _uiUtil.Dom6.addClass(this.itemInputEl, "fa-".concat(checkboxIcon.uncheckall));
}
/**
 * renderCheckboxUnchecked
 * @access private
 */


function renderCheckboxUnchecked() {
  _uiUtil.Dom6.removeClass(this.itemInputEl, "fa-".concat(checkboxIcon.checkall, " fa-").concat(checkboxIcon.uncheckall));

  _uiUtil.Dom6.addClass(this.itemInputEl, "fa-".concat(checkboxIcon.unchecked));
}
/**
 * render
 * @access private
 */


function render() {
  var _this$config3 = this.config,
      label = _this$config3.label,
      leaf = _this$config3.leaf,
      icon = _this$config3.icon,
      iconColor = _this$config3.iconColor,
      _this$config3$attr = _this$config3.attr,
      attr = _this$config3$attr === void 0 ? {} : _this$config3$attr;
  this.el = _uiUtil.Dom6.createElement("<div class=\"".concat(selectorPrefix, "node ").concat(this.isExpand ? 'expand' : '', "\">\n        <div class=\"").concat(selectorPrefix, "item\">\n          <span class=\"").concat(selectorPrefix, "item-trigger ").concat(leaf ? 'invisible' : '', " ").concat(normalTriggerIcon, "\"></span>\n          ").concat(renderInput.call(this), "\n          <span class=\"").concat(selectorPrefix, "item-icon fa fa-").concat(icon, " ").concat(!icon ? 'invisible' : '', "\" style=\"color:").concat(iconColor || '', "\"></span>\n          <span class=\"").concat(selectorPrefix, "item-label\">\n            <span class=\"").concat(selectorPrefix, "item-text\">").concat(label, "</span>\n          </span>\n        </div>\n      </div>\n    "));

  _uiUtil.Dom6.objectToDataSet(attr, this.el);

  initVar.call(this);
  initEvents.call(this);
}
/**
 * TreeNode
 * @class TreeNode
 * @classdesc TreeNode
 */


var TreeNode =
/*#__PURE__*/
function () {
  /**
   * constructor
   * @constructor
   * @param {Object} - globalConfig 全局的节点配置
   * @param {Object} - config 节点的配置
   * @param {Tree} - tree Tree
   * @param {TreeNode} - parentNode 父节点
   */
  function TreeNode(_ref) {
    var globalConfig = _ref.globalConfig,
        config = _ref.config,
        tree = _ref.tree,
        parentNode = _ref.parentNode;
    (0, _classCallCheck2["default"])(this, TreeNode);
    this.nodeGlobalConfig = JSON.parse(JSON.stringify(globalConfig));
    this.nodeConfig = JSON.parse(JSON.stringify(config));
    this.config = JSON.parse(JSON.stringify(Object.assign({}, globalConfig, config)));
    this.tree = tree;
    this.parentNode = parentNode; // 子节点

    this.childrenNodes = []; // 如果loadType==='remote'时，判断是否加载过数据

    this.isload = false; // 如果loadType==='remote'时，的节流锁

    this.lock = false;
    this.events = tree.events;
    var _this$config4 = this.config,
        _this$config4$expand = _this$config4.expand,
        expand = _this$config4$expand === void 0 ? true : _this$config4$expand,
        loadType = _this$config4.loadType; // 节点是否展开

    this.isExpand = loadType === 'remote' ? false : expand;
    render.call(this);
  }
  /**
   * append
   * tree是一个完整的对象，已经调用完renderChildren
   * @param {TreeNode} - treeNode
   * @param {boolean} - refresh
   */


  (0, _createClass2["default"])(TreeNode, [{
    key: "append",
    value: function append(treeNode) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var loadType = this.config.loadType;

      if (this.isLeaf()) {
        this.childrenEl = _uiUtil.Dom6.createElement('<div class="ct-tree-children"></div>');
        var paddingLeft = getChildrenPaddingLeft.call(this);
        this.childrenEl.style.paddingLeft = "".concat(paddingLeft, "px");
        this.el.appendChild(this.childrenEl); // if (loadType !== 'remote') {
        //   this.itemTriggerEl = Dom6.createElement(`<span class="${selectorPrefix}item-trigger ${normalTriggerIcon}"></span>`);
        //   Dom6.prepend(this.itemEl, this.itemTriggerEl);
        // }
      }

      this.childrenEl.appendChild(treeNode.getEl());
      this.childrenNodes.push(treeNode);

      _uiUtil.Dom6.removeClass(this.itemTriggerEl, 'invisible');

      if (loadType === 'remote' && !this.isload) {
        this.isload = true;
      }

      if (refresh) {
        this.refresh();
      }
    }
    /**
     * appendByConfig
     * @param {Object} - config
     */

  }, {
    key: "appendByConfig",
    value: function appendByConfig(config) {
      var globalConfig = this.nodeGlobalConfig;
      var newNode = new TreeNode({
        globalConfig: globalConfig,
        config: config,
        tree: this.tree,
        parentNode: this
      });
      this.tree.renderChildren({
        parentNode: newNode,
        globalConfig: globalConfig,
        config: config
      });
      this.append(newNode);
      this.refresh();
    }
    /**
     * prepend
     * @param {TreeNode} - treeNode
     */

  }, {
    key: "prepend",
    value: function prepend(treeNode) {
      if (this.isLeaf()) this.append(treeNode);

      _uiUtil.Dom6.prepend(this.childrenEl, treeNode.getEl());

      this.childrenNodes.unshift(treeNode);
      this.refresh();
    }
    /**
     * prependByConfig
     * @param {Object} - config
     */

  }, {
    key: "prependByConfig",
    value: function prependByConfig(config) {
      var globalConfig = this.nodeGlobalConfig;
      var newNode = new TreeNode({
        globalConfig: globalConfig,
        config: config,
        tree: this.tree,
        parentNode: this
      });
      this.tree.renderChildren({
        parentNode: newNode,
        globalConfig: globalConfig,
        config: config
      });
      this.prepend(newNode);
    }
    /**
     * insertBefore
     * @param {TreeNode} - treeNode
     * @param {TreeNode} - newNode
     */

  }, {
    key: "insertBefore",
    value: function insertBefore(treeNode, newNode) {
      if (!treeNode || !newNode) return false;
      var index = this.childrenNodes.findIndex(function (n) {
        return n === treeNode;
      });

      if (index === -1) {
        this.append(newNode);
        this.refresh();
      } else if (index === 0) {
        this.prepend(newNode);
      } else {
        // dom
        this.childrenEl.insertBefore(newNode.getEl(), treeNode.getEl()); // array

        this.childrenNodes.splice(index, 0, newNode);
        this.refresh();
      }
    }
    /**
     * insertBeforeByConfig
     * @param {TreeNode} - treeNode
     * @param {Object} - config
     */

  }, {
    key: "insertBeforeByConfig",
    value: function insertBeforeByConfig(treeNode, config) {
      var globalConfig = this.nodeGlobalConfig;
      var newNode = new TreeNode({
        globalConfig: globalConfig,
        config: config,
        tree: this.tree,
        parentNode: this
      });
      this.tree.renderChildren({
        parentNode: newNode,
        globalConfig: globalConfig,
        config: config
      });
      this.insertBefore(treeNode, newNode);
    }
    /**
     * insertAfter
     * @param {TreeNode} - treeNode
     * @param {TreeNode} - newNode
     */

  }, {
    key: "insertAfter",
    value: function insertAfter(treeNode, newNode) {
      if (!treeNode || !newNode) return false;
      var index = this.childrenNodes.findIndex(function (n) {
        return n === treeNode;
      });

      if (index === -1) {
        this.append(newNode);
        this.refresh();
      } else if (index === this.childrenNodes.length - 1) {
        this.prepend(newNode);
      } else {
        // dom
        _uiUtil.Dom6.insertAfter(newNode.getEl(), treeNode.getEl()); // array


        this.childrenNodes.splice(index + 1, 0, newNode);
        this.refresh();
      }
    }
    /**
     * insertAfterByConfig
     * @param {TreeNode} - treeNode
     * @param {Object} - config
     */

  }, {
    key: "insertAfterByConfig",
    value: function insertAfterByConfig(treeNode, config) {
      var globalConfig = this.nodeGlobalConfig;
      var newNode = new TreeNode({
        globalConfig: globalConfig,
        config: config,
        tree: this.tree,
        parentNode: this
      });
      this.tree.renderChildren({
        parentNode: newNode,
        globalConfig: globalConfig,
        config: config
      });
      this.insertAfter(treeNode, newNode);
    }
    /**
     * replaceNode
     * @param {TreeNode} - treeNode
     * @param {TreeNode} - newNode
     * @return {boolean}
     */

  }, {
    key: "replaceNode",
    value: function replaceNode(treeNode, newNode) {
      if (!treeNode || !newNode) return false;
      var index = this.childrenNodes.findIndex(function (n) {
        return n === treeNode;
      });
      if (index === -1) return false;
      this.childrenEl.replaceChild(newNode.getEl(), treeNode.getEl());
      this.childrenNodes.splice(index, 1, newNode);
      this.refresh();
    }
    /**
     * replaceNodeByConfig
     * @param {TreeNode} - treeNode
     * @param {Object} - config
     */

  }, {
    key: "replaceNodeByConfig",
    value: function replaceNodeByConfig(treeNode, config) {
      var globalConfig = this.nodeGlobalConfig;
      var newNode = new TreeNode({
        globalConfig: globalConfig,
        config: config,
        tree: this.tree,
        parentNode: this
      });
      this.tree.renderChildren({
        parentNode: newNode,
        globalConfig: globalConfig,
        config: config
      });
      this.replaceNode(treeNode, newNode);
    }
    /**
     * removeChildren
     * @param {TreeNode} treeNode
     */

  }, {
    key: "removeChildren",
    value: function removeChildren(treeNode) {
      if (!treeNode) return false;
      if (this.isLeaf()) return false;
      var index = this.childrenNodes.findIndex(function (n) {
        return n === treeNode;
      });
      if (index === -1) return false;
      this.childrenNodes.splice(index, 1);

      _uiUtil.Dom6.remove(treeNode.getEl());

      if (this.isLeaf()) {
        _uiUtil.Dom6.addClass(this.itemTriggerEl, 'invisible');
      }

      this.refresh();
    }
    /**
     * childrenNodes
     * @return {Array}
     */

  }, {
    key: "childrens",
    value: function childrens() {
      return [].concat(this.childrenNodes);
    }
    /**
     * expand
     * @param {Boolean} - expaned
     */

  }, {
    key: "expand",
    value: function expand(expaned) {
      _expand.call(this, expaned);
    }
    /**
     * resetRemoteNode
     * 重置loadType === 'remote' 的节点使其能够重新载入数据，并且先闭合节点
     */

  }, {
    key: "resetRemoteNode",
    value: function resetRemoteNode() {
      var loadType = this.config.loadType;
      if (loadType !== 'remote') return false;
      this.expand(false);
      this.isload = false;
    }
    /**
     * isExpand
     * @return {Boolean}
     */

  }, {
    key: "isExpand",
    value: function isExpand() {
      return this.isExpand;
    }
    /**
     * getAttr
     * @param {String} - attr
     * @return {String} - value
     */

  }, {
    key: "getAttr",
    value: function getAttr(attr) {
      return this.el.dataset[attr];
    }
    /**
     * setAttr
     * @param {String} - key
     * @param {String} - value
     */

  }, {
    key: "setAttr",
    value: function setAttr(key, value) {
      this.el.dataset[key] = value;
    }
    /**
     * hasAttr
     * @param {String} - key
     * @param {String} - value
     * @return {boolean}
     */

  }, {
    key: "hasAttr",
    value: function hasAttr(key, value) {
      var srcValue = this.getAttr(key);
      return value === srcValue;
    }
    /**
     * getLabel
     * @return {String}
     */

  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.itemTextEl.innerText;
    }
    /**
     * setLabel
     * @param {String} - label
     */

  }, {
    key: "setLabel",
    value: function setLabel(label) {
      this.itemTextEl.innerText = label;
    }
    /**
     * setIcon
     * @param {String} - icon
     */

  }, {
    key: "setIcon",
    value: function setIcon(newIcon) {
      var self = this;
      var _this$config5 = this.config,
          srcIcon = _this$config5.icon,
          iconColor = _this$config5.iconColor;

      function createIcon() {
        self.config.icon = newIcon;
        self.itemIconEl = _uiUtil.Dom6.createElement("<span class=\"".concat(selectorPrefix, "item-icon fa fa-").concat(newIcon, "\" style=\"color:").concat(iconColor || '', "\"></span>"));

        _uiUtil.Dom6.prepend(self.itemLabelEl, self.itemIconEl);
      }

      if (!srcIcon) {
        createIcon();
      } else if (!this.itemIconEl) {
        createIcon();
      } else {
        this.config.icon = newIcon;

        _uiUtil.Dom6.removeClass(this.itemIconEl, "fa fa-".concat(srcIcon));

        _uiUtil.Dom6.addClass(this.itemIconEl, "fa fa-".concat(newIcon));
      }
    }
    /**
     * getIcon
     * @return {String}
     */

  }, {
    key: "getIcon",
    value: function getIcon() {
      return this.config.icon;
    }
    /**
     * setIconColor
     * @param {String} - iconColor
     */

  }, {
    key: "setIconColor",
    value: function setIconColor(iconColor) {
      var icon = this.config.icon;
      if (!icon) return false;
      if (!this.itemIconEl) return false;
      this.config.iconColor = iconColor;
      this.itemIconEl.style.color = iconColor;
    }
    /**
     * getIconColor
     * @return {string}
     */

  }, {
    key: "getIconColor",
    value: function getIconColor() {
      return this.config.iconColor;
    }
    /**
     * isLeaf
     * @return {Boolean}
     */

  }, {
    key: "isLeaf",
    value: function isLeaf() {
      return this.childrenNodes.length <= 0;
    }
    /**
     * isRoot
     * @return {boolean}
     */

  }, {
    key: "isRoot",
    value: function isRoot() {
      return !!this.parentNode;
    }
    /**
     * getEl
     * @return {HTMLElement}
     */

  }, {
    key: "getEl",
    value: function getEl() {
      return this.el;
    }
    /**
     * checked
     * @return {boolean}
     */

  }, {
    key: "isChecked",
    value: function isChecked() {
      if (this.isCheckboxType()) {
        if (this.itemInputFieldEl) {
          return this.itemInputFieldEl.checked;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    /**
     * isSubChecked
     * @return {boolean}
     */

  }, {
    key: "isSubChecked",
    value: function isSubChecked() {
      if (this.isCheckboxType()) {
        if (this.itemInputEl) {
          return this.itemInputEl.classList.contains("fa-".concat(checkboxIcon.uncheckall));
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    /**
     * getType
     * @return {string}
     */

  }, {
    key: "getType",
    value: function getType() {
      return this.config.type;
    }
    /**
     * getParentNode
     * @return {TreeNode}
     */

  }, {
    key: "getParentNode",
    value: function getParentNode() {
      return this.parentNode;
    }
    /**
     * isCheckboxType
     * @return {boolean}
     */

  }, {
    key: "isCheckboxType",
    value: function isCheckboxType() {
      return ['checkbox', 'radio'].indexOf(this.config.type) !== -1;
    }
    /**
     * checkboxDrillUp
     */

  }, {
    key: "checkboxDrillUp",
    value: function checkboxDrillUp() {
      //   if(父节点的所有checkbox节点都选中) {
      //     父节点渲染成选中状态 - 一直向上追溯
      //   }
      var isCheckbox = this.isCheckboxType();
      if (!isCheckbox) return false;
      var checkboxNodes = [];

      for (var i = 0; i < this.childrenNodes.length; i++) {
        var treeNode = this.childrenNodes[i];

        if (treeNode.itemInputFieldEl) {
          checkboxNodes.push(treeNode);
        }
      }

      var checkeds = checkboxNodes.filter(function (node) {
        return node.isChecked();
      }); // 子元素都选中了

      if (checkeds.length === checkboxNodes.length) {
        this.itemInputFieldEl.checked = true;
        renderCheckboxCheckAll.call(this);
        this.events.trigger('checked', this, true);

        if (this.parentNode) {
          this.parentNode.checkboxDrillUp();
        }
      } else {
        this.itemInputFieldEl.checked = false;

        if (checkeds.length !== 0) {
          // 子节点有选中的
          renderCheckboxUncheckall.call(this);
        } else {
          var subCheckeds = checkboxNodes.filter(function (node) {
            return node.isSubChecked();
          });

          if (subCheckeds.length !== 0) {
            renderCheckboxUncheckall.call(this);
          } else {
            renderCheckboxUnchecked.call(this);
          }
        }

        this.events.trigger('checked', this, false);

        if (this.parentNode) {
          this.parentNode.checkboxDrillUp();
        }
      }
    }
    /**
     * detailItemInputsRecursive
     */

  }, {
    key: "detailItemInputsRecursive",
    value: function detailItemInputsRecursive() {
      var _this$config$checkedC3 = this.config.checkedCascade,
          checkedCascade = _this$config$checkedC3 === void 0 ? true : _this$config$checkedC3;

      if (checkedCascade) {
        if (this.isLeaf()) {
          if (this.getType() === 'checkbox') {
            if (this.isChecked()) {
              renderCheckboxCheckAll.call(this);
            } else {
              renderCheckboxUnchecked.call(this);
            }

            var parentNode = this.getParentNode();

            if (parentNode) {
              parentNode.checkboxDrillUp();
            }
          }
        } else {
          var children = this.childrens();

          for (var i = 0; i < children.length; i++) {
            children[i].detailItemInputsRecursive();
          }
        }
      } else if (this.isChecked()) {
        renderCheckboxCheckAll.call(this);
      } else {
        renderCheckboxUnchecked.call(this);
      }
    }
    /**
     * checked
     * @param {boolean} - check
     */

  }, {
    key: "checked",
    value: function checked(check) {
      var _this$config$checkedC4 = this.config.checkedCascade,
          checkedCascade = _this$config$checkedC4 === void 0 ? true : _this$config$checkedC4;

      if (!checkedCascade) {
        if (this.events.hasType('beforeChecked')) {
          var flag = this.events.trigger('beforeChecked', this, check);

          if (flag) {
            checkedDetail.call(this, check);
          }
        } else {
          checkedDetail.call(this, check);
        }
      } else {
        checkedDetail.call(this, check);
      }
    }
    /**
     * refresh
     */

  }, {
    key: "refresh",
    value: function refresh() {
      var parentNode = this.getParentNode();

      if (parentNode) {
        parentNode.detailItemInputsRecursive();
      } else {
        this.detailItemInputsRecursive();
      }
    }
  }]);
  return TreeNode;
}();

var _default = TreeNode;
exports["default"] = _default;